
<template>
    <div>
        <header-component></header-component>

        <component :is="innerWelcomeBannerComponent"></component>

        <activated-offers-component
            v-if="activatedOffers.length > 0"
            :activatedOffers="activatedOffers"
            category="activated"
        ></activated-offers-component>

        <!-- Featured offers slider -->
        <div>
            <!--            <search-view-component  @showView="changeView"></search-view-component>-->
            <search-view-component
                class="mb-5"
                @onChange="onSearchChange($event)"
                @showView="changeView"
            ></search-view-component>
            <!--            @inputChanged="onSearchChange($event)"-->
            <!-- <div class="input-group mb-3">
                <input type="text" class="form-control" v-model="zip" placeholder="Enter Zip" aria-label="" aria-describedby="button-addon2" />
            </div> -->
            <div class="loadingNearByOffers">
                <transition name="fade">
                    <font-awesome-icon  v-show="loadingNearByOffers" icon="fa-solid fa-spinner fa-2xl" spin />
                </transition>
            </div>
            <featured-offers-slider-component
                v-if="showList"
                :featuredOffers="featuredOffers"
            ></featured-offers-slider-component>
            <featured-offers-map-component
                v-if="showMap"
                :nearestOffers="nearestOffers"
                :showMapError="showMapError"
                :offerLocations="offerLocations"
                :mapCenter="mapCenter"
                @getOffersByLocation="getOffersToDisplay"
            ></featured-offers-map-component>
            <!-- <div v-if="showMap" style="height: 350px" class="col-md-12">
                    <map-component :offerLocations = "offerLocations" :mapCenter = "mapCenter"> </map-component>
                </div> -->
        </div>

        <category-offers-component
            :matchedOffers="category_1_offers"
            category="dining_and_entertainment"
            categoryTitle="Dining And Entertainment"
        ></category-offers-component>

        <category-offers-component
            :matchedOffers="category_2_offers"
            category="shopping"
            categoryTitle="Shopping"
            class="bg-fadeblue"
        ></category-offers-component>

        <category-offers-component
            :matchedOffers="category_3_offers"
            v-if="(category_3_offers.length > 0)"
            category="travel"
            categoryTitle="Travel"
            class="bg-fadeblue"
        ></category-offers-component>

        <category-offers-component
            v-if="(category_4_offers.length > 0)"
            :matchedOffers="category_4_offers"
            category="health_and_wellness"
            categoryTitle="Health And Wellness"
            class="bg-fadeblue"
        ></category-offers-component>

        <category-offers-component
            v-if="(category_5_offers.length > 0)"
            :matchedOffers="category_5_offers"
            category="other"
            categoryTitle="Other"
            class="bg-fadeblue"
        ></category-offers-component>

        <!--        <category-offers-component-->
        <!--            :matchedOffers="category_3_offers"-->
        <!--            category="electronics"-->
        <!--            class="bg-fadeblue"-->
        <!--        ></category-offers-component>-->

        <div class="button-container no-margin">
            <a href="javascript:;" @click="navigateToAllCategoriesSearch" class="button rounded-0 pink midsize full-width py-5 text-center">View All Categories</a>
        </div>

        <!-- Promotional offers -->
        <promotional-offers-component></promotional-offers-component>

        <!-- Footer -->
        <footer-component>
            <template v-slot:after-links v-if="showPromotionalBanner">
                <post-login-disclosure />
            </template>
        </footer-component>
    </div>
</template>

<script>
import InnerWelcomeBannerComponent from "./banners/InnerWelcomeBannerComponent.vue";
import InnerWelcomeBannerPromotionComponent from "./banners/InnerWelcomeBannerPromotionComponent.vue";
import ActivatedOffersComponent from "./ActivatedOffersComponent.vue";
import OffersBlockComponent from "./OffersBlockComponent.vue";
import FooterComponent from "./FooterComponent.vue";
import CategoryOffersComponent from "./CategoryOffersComponent.vue";
import HeaderComponent from "./HeaderComponent.vue";
import FeaturedOffersSliderComponent from "./FeaturedOffersSliderComponent.vue";
import FeaturedOffersMapComponent from "./FeaturedOffersMapComponent.vue";
import PromotionalOffersComponent from './PromotionalOffersComponent.vue';
import PostLoginDisclosure from "./promotions/PostLoginDisclosure.vue";

export default {
    components: {
        InnerWelcomeBannerComponent,
        InnerWelcomeBannerPromotionComponent,
        PostLoginDisclosure,
        OffersBlockComponent,
        ActivatedOffersComponent,
        FooterComponent,
        CategoryOffersComponent,
        HeaderComponent,
        FeaturedOffersSliderComponent,
        FeaturedOffersMapComponent,
        PromotionalOffersComponent,
    },
    data() {
        return {
            showMap: false,
            loadingNearByOffers: false,
            showMapError: null,
            showList: true,
            zipFromUserTable: null,
            user: null,
            offerLocations: [],
            nearestOffers: [],
            mapCenter: {},
            category_1_offers: [],
            category_2_offers: [],
            category_3_offers: [],
            category_4_offers: [],
            category_5_offers: [],
            featuredOffers: [],
            activatedOffers: [],
            showPromotionalBanner: window.appGlobalData.showPromotionalBanner,
            innerWelcomeBannerComponent : window.appGlobalData.showPromotionalBanner?InnerWelcomeBannerPromotionComponent:InnerWelcomeBannerComponent
        };
    },
    methods: {
        navigateToAllCategoriesSearch () {
            let routeData = this.$router.resolve({name: 'all-categories'});
            window.open(routeData.href, '_self');
        },
        getMatchedOffers({type = null, category = null, grouping = null}) {

            let payload = {
                PageNumber: 1,
                ItemsPerPage: 8,
                offset: 0
            };

            if(grouping) {
                payload.grouping = grouping;
            }
            else {

                if (type === "featured") {
                    payload.filter = "featured";
                    payload.ItemsPerPage = 50;
                } else if (type === "activated") {
                    payload.filter = "activated";
                    payload.ItemsPerPage = 4;
                    payload.ActiveSc = 'ACTIVATED_STATEMENT_CREDIT'
                }

                if (category) {
                    payload.Category = category;
                }
            }

            axios
                .post(this.apiEndPoints.matchedOffers, payload)
                .then((response) => {
                    if(grouping) {
                        let offersCategories = response?.data?.Response?.Items?.categories;
                        for(const gtype in offersCategories) {
                            let offers = offersCategories[gtype]?.Items?.MatchedOffer;
                            if(offers !== undefined) {
                                this.setOffersByType(offers,null,gtype)
                            }
                        }
                        let offersTypes = response?.data?.Response?.Items?.types;
                        for(const gtype in offersTypes) {
                            let offers = offersTypes[gtype]?.Items?.MatchedOffer;
                            if(offers !== undefined) {
                                this.setOffersByType(offers, gtype)
                            }
                        }
                    }
                    else {
                        let offers = response?.data?.Response?.Items?.MatchedOffer;
                        if(offers !== undefined) {
                            this.setOffersByType(offers, type, category)
                        }
                    }
                })
                .catch((error) => {
                    // console.error(error, 'here');
                    // console.error(error.status,'here')

                    if (error.response.status == 401 || error.response.status == 419) {
                        this.$router.push({name : 'sign_in'});
                    }
                });
        },
        setOffersByType(offers, type = null, category = null) {
            if (type == 'featured') {
                this.featuredOffers = offers;
            } else if (type == 'activated') {
                this.activatedOffers = offers;
            } else if (category == 'dining_and_entertainment') {
                this.category_1_offers = offers;
            } else if (category == 'shopping') {
                this.category_2_offers = offers;
            } else if (category == 'travel') {
                this.category_3_offers = offers;
            } else if (category == 'health_and_wellness') {
                this.category_4_offers = offers;
            } else if (category == 'other') {
                this.category_5_offers = offers;
            } else {
            }
        },
        getOffersToDisplay(zip = null, currentLocation = null) {
            this.showMapError = false;
            this.loadingNearByOffers = true;
            let payload = {};
            payload.PageNumber = 1;
            payload.ItemsPerPage = 20;

            if (this.showMap) {
                payload.getOffersForMap = 1;
            }

            if(currentLocation && currentLocation.longitude && currentLocation.latitude) {
                payload.currentLongitude = currentLocation.longitude;
                payload.currentLatitude = currentLocation.latitude;
            }

            if(zip) {
                payload.zip = zip;
            }
            // e.preventDefault();
            axios
                .post(this.apiEndPoints.matchedOffers, payload)
                .then((response) => {
                    let matchedOffers = response?.data?.Response?.Items?.MatchedOffer;

                    if (this.showMap) {
                        if (matchedOffers !== undefined && matchedOffers.length) {
                            this.nearestOffers = matchedOffers;
                            this.offerLocations = matchedOffers.map((a,index) => {
                                let innerObj = a.Merchant.Addresses.Address[0];
                                innerObj["MerchantName"] = a.Merchant.Name;
                                innerObj["Category"] = a.Merchant.Category;
                                innerObj["Name"] = a.Merchant.Name;
                                innerObj["Headline"] = a.Headline;
                                innerObj["OfferNumber"] = index+1;
                                innerObj["offerId"] = a.OfferId;
                                innerObj["offerProvider"] = a.OfferProvider;
                                return innerObj;
                            });
                        }



                        let mapCenter = response?.data?.Response?.MapCenter;

                        if (
                            mapCenter !== undefined &&
                            mapCenter.longitude &&
                            mapCenter.latitude
                        ) {
                            this.mapCenter = mapCenter;
                        }
                    }

                    if(matchedOffers !== undefined && matchedOffers.length == 0){
                        this.showMapError = "No offers found in this location. Please try different zip.";
                    }

                    if (response.data && response.data.status) {
                        if (response.data.status == "success") {

                        } else if (response.data.message) {
                            // this.errors.push(response.data.message);
                            this.showMapError = response.data.message;
                        } else {
                            // this.errors.push("An error occurred. Please try again!");
                            this.showMapError = "An error occurred. Please try again!";
                        }
                    }
                })
                .catch((error) => {
                    if(error.response.data && error.response.data.message) {
                        this.showMapError = error.response.data.message;
                    }
                }).finally(() => {
                this.loadingNearByOffers = false;
            });
        },

        changeView(view) {
            if (view == "map") {
                this.loadingNearByOffers = true;
                if(navigator.geolocation) {
                    navigator.geolocation.getCurrentPosition(
                        position => {

                            this.mapCenter = {
                                longitude : position.coords.longitude,
                                latitude : position.coords.latitude,
                            };
                            this.getOffersToDisplay(null, {
                                longitude : position.coords.longitude,
                                latitude : position.coords.latitude,
                            } );
                        },
                        error => {
                            this.getOffersToDisplay(this.zipFromUserTable);
                        }
                    )

                } else {
                    this.getOffersToDisplay(this.zipFromUserTable);
                }

                this.showMap = true;
                this.showList = false;

            } else {
                this.getMatchedOffers({ type: "featured" });
                this.showMap = false;
                this.showList = true;
            }
        },

        onSearchChange(merchantName) {
            // if(merchantName.length) {
            let routeData = this.$router.resolve({
                name: 'search-results',
                query: {search_term: merchantName, category: 'all', hideCategories: true}
            });
            window.open(routeData.href, '_self');
            // }
        },
    },
    mounted() {
        if (localStorage.getItem("user_obj")) {
            this.user = JSON.parse(localStorage.getItem("user_obj"));
            this.zipFromUserTable = this.user.postal_code;
        }

        const categories = ['dining_and_entertainment','shopping', 'travel', 'health_and_wellness', 'other'];
        const grouping = {
            types : [
                {
                    name : "featured",
                    ItemsPerPage : 50
                },
                {
                    name : "activated",
                    ItemsPerPage: 4,
                    ActiveSc : "ACTIVATED_STATEMENT_CREDIT"
                }
            ],
            categories : categories.map((cat)=>{
                return {
                    name : cat
                }
            })
        }
        this.getMatchedOffers({ grouping  });

    },
};
</script>

<style scoped>

.loadingNearByOffers {
    text-align: center;
    position: fixed;
    color: darkgray;
    z-index: 200;
    font-size: 5vw;
    /*background: #5c4084;*/
    /*padding: 8px 18px;*/
    /*border-radius: 5px;*/
    left: calc(50% - 45px);
    top: calc(50% - 18px);
}

.fade-enter-active, .fade-leave-active {
    transition: opacity 2s
}
.fade-enter, .fade-leave-to {
    opacity: 0
}

</style>
